import Vue from 'vue';
import Message from './loading-mask.vue';
const MessageConstructor = Vue.extend(Message);
let instance;
const div = document.createElement('div');

const Initinstance = option => {
  const type = typeof option;
  if (type !== 'object') {
    throw new Error('option must be object');
  }
  instance = new MessageConstructor({
    el: div
  });
  document.querySelector('#app')?.appendChild(instance.$el);
  setTimeout(() => {}, 0);
};

const MessageBox = option => {
  Initinstance(option);
  return {
    close: () => {
      instance.$destroy();
      document.querySelector('#app')?.removeChild(instance.$el);
    }
  };
};

MessageBox.show = option => {
  return MessageBox(option);
};

MessageBox.close = () => {
  instance.$destroy();
  document.querySelector('#app')?.removeChild(instance.$el);
};

export default MessageBox;
